export * from "./types";

const PROD_IFRAME_WALLET = "https://wallet.connext.network";

export const iframeSrc = PROD_IFRAME_WALLET;
